var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar background"},[_c('div',{staticClass:"bar progress",style:(_vm.progressStyle)},[_c('div',{staticClass:"bar loading"},[_c('div',{staticClass:"hole"},[_c('span',{style:(_vm.scoreStyle),attrs:{"id":_vm.id}},[_vm._v(" "+_vm._s(this.score)+" ")]),_c('div',{staticClass:"for-rounded-border",style:(_vm.forRoundedBorder)})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }